//活动
const activityBox = () => import('@/components/activity/activityBox');
const activityList = () => import('@/components/activity/activityList');
const addActivity = () => import('@/components/activity/activity/addActivity');
const editActivity = () => import('@/components/activity/activity/editActivity');
const editActivityPoster = () => import('@/components/activity/activity/editActivityPoster');



export default {
    path: '/activityBox',
    name: 'activityBox',
    component: activityBox,
    children: [
        { path: 'activityList', component: activityList, name: 'activityList' },
        { path: 'addActivity', component: addActivity, name: 'addActivity' },
        { path: 'editActivity', component: editActivity, name: 'editActivity' },
        { path: 'editActivityPoster', component: editActivityPoster, name: 'editActivityPoster' },
    ]
}



// WEBPACK FOOTER //
// ./src/router/routes/activity.js